import React from "react";
import NoItemPng from "./no-item.png";

const NoItemIcon = () => (
  <img src={NoItemPng} alt="no-item"  style={{ height: 160, width: 160 }} />
);

export default NoItemIcon;
